// Import Global Constants
import c from './constants.js'

// Import Vue
import Vue from 'vue'

import axios from 'axios'

// user obj

window.loggedInUserObj = {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */


// window.axios = require('axios');
window.axios = axios;

window.addEventListener('storage', (event) => {
	if (event.storageArea != localStorage) return;
	if (event.key == 'access_token') {
		if(event.newValue != null && event.newValue != '' && event.newValue != undefined){
            localStorage.setItem("access_token", event.newValue)
		    window.axios.defaults.headers.common['Authorization'] = `Bearer ${event.newValue}`;
        }else{
            ajax.signOut()
		}	
	}
	else if(event.key == 'refresh_token'){
		localStorage.setItem("refresh_token", event.newValue)
	}
   });

//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.baseURL = c.APIBASEURL;
window.axios.get('https://api.ipify.org/?format=json').then(function(res) {
	window.axios.defaults.headers.common['Client_IPAddress'] = res.data.ip;
});
window.session = {
    isRefreshTokenAPIInProgress: false,
    isTimeOutSet:false,
    create() {
        var access_Token = localStorage.getItem("access_token")
        if (access_Token != null && access_Token != "" && access_Token != undefined) {
            // var decodedAccessToken = JSON.parse(atob(access_Token.split('.')[1]));
            var decodedAccessToken = access_Token.split('.')[1];
            let base64 = decodedAccessToken.replace('-', '+').replace('_', '/');
            let decodedData = JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
            localStorage.setItem("expiry_date", new Date(decodedData.exp * 1000))
        } else {
            ajax.signOut()
        }
    },

    isActive() {
        var expiry_date = localStorage.getItem('expiry_date')
        if (expiry_date != null && expiry_date != "" && expiry_date != undefined) {
            if (!(new Date(expiry_date) > new Date())) { //Check Token is expired or not
                localStorage.setItem("expiry_message", "Session expired. Please login again.")
                    //ajax.redirectToLoginPage()
                return false
            } else { //Token Not Expired.
                var user_details = JSON.parse(localStorage.getItem('user_details'))
                if (user_details != null && user_details != "" && user_details != undefined) //Check user details exists or not
                {
                    if (user_details.orgId != null && user_details.orgId != "" && user_details.orgId != undefined) {
                        return true
                    } else {
                        ajax.redirectToSelectOrganizationPage()
                        return false
                    }
                } else {
                    ajax.signOut()
                    return false
                }
            }
        } else {
            if (window.location.href.slice(0, -1) != c.APPLICATIONBASEURL) {
                session.create()
                session.isActive()
            }
        }
    },

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
};

window.ajax = {

    // Private methods

    saveToken(accessToken, refreshToken) {
        localStorage.setItem("access_token", accessToken)
        localStorage.setItem("refresh_token", refreshToken)
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    },

    destroyToken() {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user_details");
        localStorage.removeItem("expiry_date");
        localStorage.removeItem("expiry_message");
        localStorage.removeItem("LastActivityTime");
    },

    catchException(error, errorCallback) { 
		if ( error && error.response != null && error.response != undefined && error.response.status == 401) {
			this.redirectToLoginPage();
		} else
		if (typeof errorCallback === 'undefined') {
			this.throwError(error);
		} else {
			errorCallback(error);
		}
	},
    
    throwError(error, requestDetails) {
        var isToastMessageShow = true

        /*if(error.response.status > 300){
            if(error.response.status == 401){
                isToastMessageShow = false
                localStorage.setItem("expiry_message", "Session expired. Please login again.")
                ajax.destroyToken()
                ajax.redirectToLoginPage()
            }
            else{
                requestDetails.StatusCode = error.response.status + " " + error.response.statusText
                requestDetails.Message = error.message
                ajax.sendRequestFailedData(requestDetails)
            }
        }*/

        if (isToastMessageShow) {
            Vue.prototype.$message({
                type: 'error',
                message: error.message,
                sticky: true,
                closable: true
            })
        }
    },

    redirectToSelectOrganizationPage() {
        var currentLocation = window.location.href
        if (currentLocation[currentLocation.length - 1] == '/')
            currentLocation = currentLocation.slice(0, -1)

        var selectOrgURL = c.APPLICATIONBASEURL + "/SelectOrganization"

        if (currentLocation != selectOrgURL)
            window.location.href = selectOrgURL;
    },

    redirectToLoginPage() {
        // window.location.href = c.APPLICATIONBASEURL + window.location.search;
        window.location.href = c.WSO2LOGOUTURL;
    },

    signOut() {
        ajax.destroyToken()
        ajax.redirectToLoginPage()
    },

    formatURL(url) {
        if (url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
            if (url.split('/')[0] == 'FormI539'|| url.split('/')[0] == 'FormI539A' || url.split('/')[0] == 'WorkAuthorization') {
                if (url[0] == '/') {
                    // handle url without "/"
                    return `${c.I539BASEURL}/api${url}`;
                } else {
                    return `${c.I539BASEURL}/api/${url}`;
                }
            }
            else{
                if (url[0] == "/") { // handle url without "/"
                    return `${c.APIBASEURL}${url}`;
                } else {
                    return `${c.APIBASEURL}/${url}`;
                }
            }
        }
        return url;
    },

    refreshAccessToken() {
        // Check for API Access Token
        var accessToken = localStorage.getItem('access_token');
        //  var accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1laWQiOiI1YjM5ZTc3NmQ4NjRjMzExOTg0ODEyMzciLCJ1bmlxdWVfbmFtZSI6InJhamVldkByaWdhcHMuY29tIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS9hY2Nlc3Njb250cm9sc2VydmljZS8yMDEwLzA3L2NsYWltcy9pZGVudGl0eXByb3ZpZGVyIjoiQVNQLk5FVCBJZGVudGl0eSIsIkFzcE5ldC5JZGVudGl0eS5TZWN1cml0eVN0YW1wIjoiZDY2YWFkNjAtOTk4Yy00MDU0LWJhMmEtZmZjNzcwODU0MjRmIiwicm9sZSI6IkhSTWFuYWdlciIsImlzcyI6Imh0dHBzOi8vcWFhdXRoLnJpZ2Fwcy5jb20iLCJhdWQiOiI5YWI5ODk3YjBjZTM0YjhlOWVjMDhjNWVhZDQyZjg4MyIsImV4cCI6MTU0MTU5ODQ2MCwibmJmIjoxNTQwMzg4ODYwfQ.Jp3UNxVHHoXvb-0SFeg6L_KaUhZADxvH-enCFSTThwA";
        if (accessToken !== null) {
            window.axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        }
        // Get user details
        var userDetails = localStorage.getItem("user_details");
        if (userDetails) {
            userDetails = JSON.parse(userDetails);
            window.axios.defaults.headers.common["OrgId"] = userDetails.orgId;
        }
        window.axios.defaults.headers.common["IsFromESS"] = "True";
    },

    updateUserDetails() {
        // Get user details
        var userDetails = localStorage.getItem('user_details')
        if (userDetails) {
            userDetails = JSON.parse(userDetails)

            window.loggedInUserObj.empId = userDetails.empId
            window.loggedInUserObj.name = userDetails.name
            window.loggedInUserObj.email = userDetails.email
            window.loggedInUserObj.orgId = userDetails.orgId
            window.loggedInUserObj.consultantId = userDetails.consultantId
            window.loggedInUserObj.profilepic = userDetails.profilepic
            window.loggedInUserObj.designation = userDetails.designation
            window.loggedInUserObj.isH1B = userDetails.IsH1B
            window.loggedInUserObj.OrgWebsite = userDetails.OrgWebsite
            window.loggedInUserObj.OrgName = userDetails.OrgName
            window.loggedInUserObj.HireType = userDetails.HireType
            window.loggedInUserObj.IsSupervisor = userDetails.IsSupervisor
            window.loggedInUserObj.SelectOrg = userDetails.SelectOrg
        }
    },

    loggedIn() {
        var accessToken = localStorage.getItem('access_token');

        if (accessToken !== null) {
            return true
        } else {
            return false
        }
    },
    

    // Public methods
    get(url, params, successCallback, errorCallback) {
        var that = this;

        var requestDetails = ajax.getRequestDetails(url, "Get", params)

        // Send a get request
        axios({
            method: 'get',
            url: that.formatURL(url),
            params: params,
            responseType: 'json'
        })
        .then(function(response) { 
            if (response && response.data && response.data.Message != null && response.data.Message != "" && response.data.Message == "Authorization has been denied for this request.") {
                window.location.href = "/account/login";
            } else {
                successCallback(response)
            }
        })
        .catch(function(error) {
            that.catchException(error, errorCallback);
        });
    },

    put(url, data, successCallback, errorCallback) {

        var that = this;

        var requestDetails = ajax.getRequestDetails(url, "Put", data)

        // Send a put request
        axios({
                method: 'put',
                url: that.formatURL(url),
                data: data,
                responseType: 'json'
            })
            .then(function(response) {
                if (response && response.data && response.data.Message != null && response.data.Message != "" && response.data.Message == "Authorization has been denied for this request.") {
                    window.location.href = "/account/login";
                } else {
                    successCallback(response)
                }
                /** Its a temporary fix, need to relook again
            if (response.data.State === true)
		        successCallback(response);
		    else
		        that.throwError('500 - Internal Server Error'); **/
            })
            .catch(function(error) {
				that.catchException(error, errorCallback);
			});
    },

    post(url, data, successCallback, errorCallback) {

        var that = this;

        var requestDetails = ajax.getRequestDetails(url, "Post", data)

        // Send a post request
        axios({
                method: 'post',
                url: that.formatURL(url),
                data: data,
                async: false,
                responseType: 'json'
            })
            .then(function(response) {
                if (response && response.data && response.data.Message != null && response.data.Message != "" && response.data.Message == "Authorization has been denied for this request.") {
                    window.location.href = "/account/login";
                } else {
                    successCallback(response)
                }

                /** Its a temporary fix, need to relook again
            if (response.data.State === true)
		        successCallback(response);
		    else
		        that.throwError('500 - Internal Server Error'); **/
            })
            .catch(function(error) {
				that.catchException(error, errorCallback);
			});
    },

    getRequestDetails(url, method, data) {
        var requestDetails = {}

        requestDetails.UserId = window.loggedInUserObj.empId
        requestDetails.AccessToken = localStorage.getItem('access_token')
        requestDetails.CurrentRole = "Employee"
        requestDetails.RequestUrl = this.formatURL(url)
        requestDetails.RequestUnformattedUrl = url
        requestDetails.RequestMethod = method
        requestDetails.RequestObj = data

        return requestDetails
    },

    sendRequestFailedData(reqData) {
        ajax.put(`LogFailedRequest`, reqData, (res) => {
            //Ignore
        })
    }
};

const interceptor = axios.interceptors.response.use(
    response => response,
    async (error) => {
        return Promise.reject(error); // Always reject, so .catch() is called for all errors
    }
);

// const interceptor = axios.interceptors.response.use(null, async(error) => {
//     if (error && error.response !=undefined && error.response.status !== 401) { // Reject promise if usual error
//         return Promise.reject(error)
//     }

//     /* When response code is 401, try to refresh the token.
//      * Eject the interceptor so it doesn't loop in case
//      * token refresh causes the 401 response */

//     // axios.interceptors.response.eject(interceptor)

//     // if (session.isRefreshTokenAPIInProgress) {
//     //     console.log(new Date())
//     //     await session.sleep(4000)
//     //     console.log(new Date())
//     //     error.config.headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`
//     //     return axios.request(error.config)
//     // } else {
//     //     session.isRefreshTokenAPIInProgress = true
//     //     ajax.refreshAccessTokenAPI(error)
//     // }
// });

// On Page Load

// Refresh the access toke
window.ajax.refreshAccessToken()

// Get the user details
window.ajax.updateUserDetails()


// WEBPACK FOOTER //
// ./src/components/Core/ajax.js